import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 11.75v4.5a2 2 0 0 0 2 2h12.5a2 2 0 0 0 2-2v-4.5m-16.5 0v-6.8c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h10.1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v6.8m-16.5 0h2.764a2 2 0 0 1 1.789 1.105l.144.29a2 2 0 0 0 1.79 1.105h3.527a2 2 0 0 0 1.789-1.106l.144-.289a2 2 0 0 1 1.79-1.105h2.763"
	})]
});
const ForwardRef = forwardRef(SvgArchive);
export { ForwardRef as ReactComponent };
